import { Modalable, ResponseStatus } from './modalable';

export class AssignmentsLink implements Modalable {
    static MODAL_ID = 'assignmentsLinkModal';
    bypassCheck = false;
    slug: string;
    title: string;
    link: string;
    digiTrainer: boolean;
    id;
    status: ResponseStatus;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getModalId(): string {
        return AssignmentsLink.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return this.bypassCheck;
    }
}
